import React, { Component } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import { ThemeContext } from '../../../context/ThemeContext'
import spinner from '../../../images/spinner.gif';
import Web3 from 'web3';
import {rpc,contracts,tokens} from '../../../env.json';
import {abi} from '../../../token_abi.json';
import {abi as contract_abi} from '../../../dist_abi.json';

export default class Ethereum extends Component {
    static contextType = ThemeContext;
    state = {
        provider:null,
        ether:0,
        dist_percent:0,
        rate:0,
        min_amount:0,
        eth_bal:0,
        bal:0,
        receivable:0,
        loading:false
    }
    async componentDidMount(){
        this.setState({provider:window.ethereum,loading:true});
        try{
            await this.connectWallet();
            let web3 = new Web3(rpc.avax);
            let eth_bal = 0;
            // let token = new web3.eth.Contract(abi,tokens.avax);
            let bal = 0;
            if(this.context.account != null){
                eth_bal = await web3.eth.getBalance(this.state.provider.selectedAddress);
                let token = new web3.eth.Contract(abi,tokens.avax);
                bal = await token.methods.balanceOf(this.context.account).call();
            }
            let contract = new web3.eth.Contract(contract_abi,contracts.avax);
            let m_amount = await contract.methods.getMinAmount().call();
            let min_amount = Number(web3.utils.fromWei(m_amount));
            let rate = await contract.methods.getRate().call();
            let {charity,development,liquidity,marketing,reserve,team} = await contract.methods.getTokenomics().call();
            // 45691749675468835391
            let dist_percent = Number(charity)+Number(development)+Number(liquidity)+Number(marketing)+Number(reserve)+Number(team);
            // console.log(dist);
            let receivable = min_amount*Number(rate)*(1-(dist_percent/100));
            this.setState({ether:min_amount,rate:Number(rate),min_amount,bal,eth_bal,dist_percent,receivable,loading:false});
            console.log("State:",this.state);
        }catch(e){
            this.setState({loading:false});
            console.log(e);
        }
    }
    connectWallet = async ()=>{
        await window.ethereum.enable();
        let web3 =new Web3(this.state.provider);
        let accounts = await web3.eth.getAccounts();
        this.context.logIn(accounts[0]);
    }
    handleFormUpdate = (e)=>{
        let ether = Number(e.target.value);
        if(ether < this.state.min_amount){
            let receivable = this.state.min_amount * this.state.rate * (1-(this.state.dist_percent/100));
            this.setState({ether:this.state.min_amount,receivable})
        }else{
            let receivable = ether * this.state.rate * (1-(this.state.dist_percent/100));
            this.setState({ether,receivable})
        }
    }
    success = (txHash ="0x1df30bc...2dfac4b") => {
        toast.success(`✅ Success ${txHash}`, {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })
    }
    switchToEthereum = async()=>{
        try {
            await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x4' }],
            });
        } catch (switchError) {
            console.log(switchError);
        }
    }
    purchaseToken = async (e)=>{
        e.preventDefault();
        // e.stopPropagation();
        console.log("case here")
        try {
            await this.connectWallet();
            await this.switchToEthereum();
            let web3 = new Web3(window.ethereum);
            let contract = new web3.eth.Contract(contract_abi,contracts.eth);
            if(this.state.ether < this.state.eth_bal){
                await contract.methods.purchase().send({from:this.context.account,value:web3.utils.toWei(this.state.ether.toString(),'ether')}).once('confirmation',(number,receipt)=>{
                    console.log(receipt);
                });
            }
        } catch (error) {
            console.log(error)
        }
    }
    render() {
        return (
            <div className="container d-flex justify-content-center position-relative">
                <ToastContainer
                  position='bottom-right'
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
                <div className="col-12 col-md-7 col-lg-5">
                    <div className="card">
                        <div className="card-header border-0 pb-0">
                            <h4 className="card-title">Buy WORK Token (ERC20) </h4>
                        </div>
                        <div className="card-body">
                            <form on onSubmit={this.purchaseToken}>
                                <div className="form-group mb-3">
                                    <label>Ethereum Amount</label>
                                    <input type="number" style={{fontSize:'18px'}} step="0.01" value={this.state.ether} onChange={this.handleFormUpdate} className="form-control input-default" />
                                </div>
                                <div className="form-group mb-5">
                                    <label>You will Receive</label>
                                    <input className="form-control input-default disabled" value={this.state.receivable} disabled/>
                                </div>
                                <div className="form-group">
                                    <label>Distribution : {this.state.rate*this.state.ether*this.state.dist_percent/100} WORK</label>
                                    {/* <label>Hello world Fees: $0.02</label> */}
                                </div>
                                <div className="form-group mb-3">
                                    <button type="submit" className="btn btn-primary w-100"> Purchase WORK</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {this.state.loading && <div className="d-flex justify-content-center align-items-center" style={{position:'fixed',zIndex:'1',backgroundColor:'#000000a9',top:0,left:0,right:0,bottom:0}}>
                    <img src={spinner} alt="" height="100" />
                </div> }
            </div>
        )
    }
}
